export default "__VITE_ASSET__CxJsf4Ck__"